export function getBtokHeaderInfo() {
  if (!isNativeAvailable()) throw new Error('getBtokHeaderInfo is not available')
  const res = window.android ? window.android.getRequestHeaderInfo() : window.getRequestHeaderInfo?.()
  // console.log('res', typeof res, res)
  if (!res) throw new Error('getBtokHeaderInfo is not available')
  try {
    return JSON.parse(res) as BtokHeaderInfo
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message)
    } else {
      throw new Error('getBtokHeaderInfo is not available')
    }
  }
}

export function getCurrentUserName(): string {
  if (isNativeAvailable()) {
    if (window.android) return window.android.getCurrentUserName() || ''
    else return window.getCurrentUserName?.() ?? ''
  }
  throw new Error('getCurrentUserName is not available')
}

/**
 * 检查原生API是否可用
 */
export function isNativeAvailable(): boolean {
  return typeof window !== 'undefined' && (!!window.android || !!window.getRequestHeaderInfo)
}

export function sendGetRequestFromH5(callbackId: string, url: string): void {
  if (isNativeAvailable()) {
    if (window.android) window.android.sendGetRequestFromH5(callbackId, url)
    else window.webkit?.messageHandlers.sendGetRequestFromH5.postMessage({ callbackId, url }) // window.sendGetRequestFromH5?.(callbackId, url)
  } else {
    throw new Error('sendGetRequestFromH5 is not available')
  }
}

export function sendPostRequestFromH5(callbackId: string, url: string, data?: unknown): void {
  if (isNativeAvailable()) {
    const postData = data ? JSON.stringify(data) : ''
    if (window.android) {
      window.android.sendPostRequestFromH5(callbackId, url, postData)
    } else window.webkit?.messageHandlers.sendPostRequestFromH5.postMessage({ callbackId, url, data: postData }) // window.sendPostRequestFromH5?.(callbackId, url, postData)
  } else {
    throw new Error('sendPostRequestFromH5 is not available')
  }
}

export function getBtokPlatform() {
  if (isNativeAvailable()) {
    if (window.android) return window.android.getApplicationBuildType()
    else return window.getApplicationBuildType?.()
  }
  throw new Error('getApplicationBuildType is not available')
}

export function openExternalBrowser(url: string): void {
  if (isNativeAvailable()) {
    if (window.android) window.android.openExternalWebPage(url)
    else window.webkit?.messageHandlers.openExternalBrowser.postMessage(url) // window.openExternalWebPage?.(url)
  } else {
    throw new Error('openExternalWebPage is not available')
  }
}

export function openBtokVipPurchaseActivity(): void {
  // 检查原生API是否可用
  if (!isNativeAvailable()) throw new Error('openBtokVipPurchaseActivity is not available')

  console.log('openBtokVipPurchaseActivity=========')

  if (window.android) window.android.openBtokVipPurchaseActivity()
  else window.webkit?.messageHandlers.openBtokVipPurchaseActivity.postMessage('') // window.openBtokVipPurchaseActivity?.()
}
